<template>
  <div class="card-wrapper">
    <div class="card-content">
      <a
        v-if="promoEnabled"
        class="promo-banner"
        :href="vehicle.promotion.url"
        :style="'background-color:' + vehicle.promotion.color"
        :target="vehicle.promotion.url_target == 1 ? '_blank ': '_self'"
      >{{ $t('components.booking.promotion') }}</a>
      <div class="top">
        <img :src="imageSrc">
        <div class="txt-wrapper">
          <div class="car-name">
            {{ vehicle.label }}
          </div>
          <div class="prices">
            <div
              class="displayed-price"
              :class="{'-large': vehiclePrice}"
              v-html="priceTxt"
            />
            <div
              v-show="agencyPrice"
              class="agency-price"
              v-html="agencyPrice"
            />
          </div>
          <div
            class="availability-wrapper"
          >
            <vehicle-availability
              :vehicle="vehicle"
              :payment="usePayment"
            />
          </div>
        </div>
      </div>
      <div class="button-wrapper">
        <rent-button
          :loading="attemptingNavigation && markAsSelected"
          @buttonclicked="selectVehicle"
          :class="yourVehicle ? 'dark' : ''"
        >
          {{ yourVehicle ? $t('commons.your_vehicle') : $t('commons.select_vehicle') }}
        </rent-button>
      </div>
    </div>
  </div>
</template>
<script>
import RentButton from '../../shared/RentButton';
import vehicleCard from '../../shared/mixins/vehicleCards';

export default {
  name: 'BookingCard',
  mixins: [vehicleCard],
  components: {
    RentButton,
    VehicleAvailability: () => import(/* webpackChunkName: "availability"  */ `../../shared/vehicleElements/VehicleAvailability`),
    
  },
  data() {
    return {
      priceHasFootNote: true,
    }
  },
  props: {
    vehicle: {
      type: Object,
      required: true,
    },
  },
  computed: {
    yourVehicle() {
      /* eslint-disable-next-line camelcase */
      if (this.vehicle?.semi_clair === this.storeVehicle?.semi_clair) {
        return true
      }
      return false
    },

    agencyPrice() {
      if (!this.pricePerDay) {
        return '';
      }

      return this.$t('components.booking.agency_price', {
        agencyPrice: this.vehiclePrice.total_no_discount.message,
      })
    },
  },
};
</script>
<style lang="scss" scoped>

.card-wrapper {
  background: white;
  color: black;
  margin: 30px 0 0 0;
  overflow: hidden;
  padding: 10px;
  position: relative;
  width: 100%;

  @include teq-breakpoint($medium) {
    max-width: calc(100% / 2 - 10px);
  }

  @include teq-breakpoint($large) {
    max-width: calc(100% / 3 - 10px);

    &:nth-child(3n) {
      margin-right: 0;
    }

    &:nth-child(n + 4) {
      margin-top: 20px;
    }
  }
}

.card-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
}

.txt-wrapper {
  width: 100%;
}

.car-name {
  @include font-size(16px);

  font-family: $f-graphie-bold;
  text-transform: uppercase;
}

.top {
  display: flex;
  margin: 0 0 10px;
}

img {
  margin: 0 15px 0 0;
  max-width: 110px;
  object-fit: contain;
}

.prices {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.displayed-price {
  @include font-size(16px);

  &.-large {
    @include font-size(20px);

    color: $sunglow;
    font-family: $f-graphie-bold;
  }
}

.displayed-price span {
  @include font-size(14px);
}

.agency-price {
  @include font-size(13px);
}

.promo-banner {
  background: #f9c200;
  color: black;
  line-height: 1;
  padding: 0;
  position: absolute;
  text-align: center;
  text-transform: uppercase;
  -webkit-transform: rotate(-31deg) translate(-39px, -27px);
  transform: rotate(-31deg) translate(-39px, -27px);
  width: 125px;

  @include font-size(12px);

  &:hover {
    color: white;
  }
}

.dark {
  background-color: $c-tundora;
  color: white;

  &:hover {
    background-color: $c-tundora;
  }
}

</style>
